var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconArrowUp = function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.538 718.038c14.308 14.127 37.319 14.054 51.482-.219l373.009-376.431 378.215 374.83c14.31 14.163 37.32 14.053 51.52-.219 14.162-14.309 14.053-37.356-.22-51.519l-401.99-398.35c-.619-.618-1.42-.764-2.039-1.346-.145-.146-.182-.328-.328-.474a36.377 36.377 0 0 0-25.631-10.558c-9.357 0-18.751 3.604-25.85 10.777l-398.35 401.99c-14.2 14.309-14.09 37.356.182 51.519z"
  })));
};

export default SvgIconArrowUp;